import { all } from 'redux-saga/effects'

import { specificSaga } from './specific/sagas'

export function* mySaga() {
  yield all([specificSaga()])
}
